import { CmsPageView } from '../components/CmsPageView';

export default function PrivacyPolicyPage() {
  return <CmsPageView code="PRIVACY_POLICY" fallbackTitle="Privacy Policy" />;
}
